import React from 'react';
import './resources.scss';
import Hyperlink from '../Hyperlink/Hyperlink';

function Resources() {
  const hyperlinkData = [
    {
      origin: '',
      href: 'https://www.nami.org/About-Mental-Illness/Mental-Health-Conditions/Depression/',
      a: 'National Alliance on Mental Illness (NAMI)'
    },
    {
      origin: '',
      href: 'https://www.mhanational.org/conditions/depression',
      a: 'Mental Health America'
    },
    {
      origin: '',
      href: 'https://www.nimh.nih.gov/health/publications/depression',
      a: 'National Institute on Mental Health'
    }
  ];
  return (
    <div className="resources">
      <p>
        Please know you and your loved ones are not alone. If you or someone you know is struggling
        emotionally or has concerns about their mental health, there are ways to get help. Please
        reach out to one of the hotlines below:
      </p>
      <ol className="resources__num">
        <li>Call the Suicide & Crisis Lifeline at 988</li>
        <li>Call the National Alliance on Mental Illness HelpLine at 1-800-950-NAMI (6264)</li>
        <li>
          Call the Substance Abuse and Mental Health Services Administration at 1-800-626-HELP
          (4357)
        </li>
        <li>Text HOME to 741741 for free, 24/7 crisis support in the U.S.</li>
      </ol>

      <p>For additional resources on clinical depression, please visit the following sites:</p>
      <ol className="resources__alp">
        {hyperlinkData.map((data, i) => {
          return (
            <li key={`resources_${i}`}>
              <Hyperlink hyperlinkData={data} />
            </li>
          );
        })}
      </ol>
    </div>
  );
}

export default Resources;
